export default "__VITE_ASSET__ySa4j32N__"